import gql from 'graphql-tag'

export const WITH_NATIONAL_HOMEPAGE = gql`
  query NationalHomepage($country: [String]!) {
    cfNationalHomepageCollection(
      limit: 1
      where: { country_contains_all: $country }
    ) {
      items {
        title
        promotionModule {
          title
          image {
            url
            title
          }
          heading
          shortDescription
          callToActionLabel
          callToActionAddress
          analyticsMetadata {
            correlationId
            title
            promotion {
              creative
            }
          }
        }
        featuresCollection {
          items {
            heroImageSet {
              master {
                url
              }
              square {
                url
              }
            }
            title
            url
            shortDescription
          }
        }
        featuredRetailersCollection {
          items {
            sys {
              id
            }
            heroImageSet {
              master {
                url
              }
              square {
                url
              }
            }
            retailerLogoSet {
              transparent {
                url
              }
              coloured {
                url
              }
            }
            title
            slug
            marketplaceShopId
            shortDescription
          }
        }
        featuredCategoriesCollection(limit: 32) {
          items {
            heroImageSet {
              master {
                url
              }
              square {
                url
              }
            }
            title
            url
            shortDescription
          }
        }
      }
    }
  }
`
